import { useStore } from 'vuex'
import { computed, ref, onMounted } from 'vue'
import FormAddressField from 'components/FormAddressField/FormAddressField.vue'
import textAreaValidator from '../../foundation/js/inputValidators/textAreaValidator'
import isObjectNotNullOrEmpty from 'foundation/js/isObjectNotNullOrEmpty'

export default {
    name: "PickUpAddress",
    components: { FormAddressField },
    props: {
        addressResults: {
            type: Array,
            required: false
        },
        displayInputErrors: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    setup() {
        const store = useStore()
        const pickUpAddressData = computed(() => store.state.checkout.stepTwo.pickUpAddressData)

        onMounted(() => {
            store.dispatch('checkout/fetchServicePoints')
            var isDeliveryDataValid = isObjectNotNullOrEmpty(pickUpAddressData.value)
            store.commit('checkout/set_delivery_data_validation_success', isDeliveryDataValid)
        })

        const getLabel = (labelKey) => store.getters['labels/getLabel']({ labelCollection: 'pickUpAddress', labelKey: labelKey })
        const getFormAddressFieldLabel = (labelKey) => store.getters['labels/getLabel']({ labelCollection: 'checkout', labelKey: labelKey })

        const unSubmitted = ref(true)

        const addressResults = computed(() => store.state.checkout.stepTwo.pickUpAddresses)

        const addressRadioInput = ref('')

        const addressLineInput = ref('')
        const addressLineInputFilled = computed(() => {
            return addressLineInput.value.length > 2  && textAreaValidator(addressLineInput.value)
        })

        const postalCodeInput = ref('')
        const postalCodeInputFilled = computed (() => {
            return !addressLineInput.value ? true : postalCodeInput.value.length === 4  && textAreaValidator(addressLineInput.value)
        })

        const cityInput = ref('')
        const cityInputFilled = computed (() => {
            return !addressLineInput.value ? true : cityInput.value.length > 2 && textAreaValidator(addressLineInput.value)
        })

        const inputIsValid = function () {
            let addressFilled = addressLineInputFilled.value

            return (
                addressFilled 
            )
        }

        const handleAddressSelected = function (e) {
            // Update referenced fields with emitted data from child component
            addressLineInput.value = e.addressLine
            postalCodeInput.value = e.zipCode
            cityInput.value = e.city
            onSubmit()
        }

        const onSubmit = function () {
            unSubmitted.value = false
            if (!inputIsValid())
                return false

            addressRadioInput.value = {}
            store.commit('checkout/clear_pick_up_address_data')

            // set active delivery address as default to invoice address
            store.commit('checkout/set_active_delivery_address', {
                addressLine: addressLineInput.value,
                postalCode: postalCodeInput.value
            })

            // insert correct data from search dawa inputs to fetch service points
            store.dispatch('checkout/fetchServicePoints')
        }

        const setPickUpAddressInStore = function () {

            store.commit('checkout/set_delivery_data_validation_success', addressRadioInput.value ? true : false)

            store.commit('checkout/set_pick_up_address_data', {
                addressLine: addressRadioInput.value.addressLine,
                city: addressRadioInput.value.city,
                postalCode: addressRadioInput.value.zipCode,
                id: addressRadioInput.value.id,
                name: addressRadioInput.value.name,
                latitude: addressRadioInput.value.latitude,
                longitude: addressRadioInput.value.longitude
            })
        }

        return {
            onSubmit,
            setPickUpAddressInStore,
            handleAddressSelected,

            pickUpAddressData,

            addressLineInputFilled,
            postalCodeInputFilled,
            cityInputFilled,
            addressLineInput,
            postalCodeInput,
            cityInput,
            addressRadioInput,

            addressResults,

            getLabel,
            getFormAddressFieldLabel
        }

    }
}